import { render, staticRenderFns } from "./LoginAlertPopup.vue?vue&type=template&id=3534f123&scoped=true"
import script from "./LoginAlertPopup.vue?vue&type=script&lang=js"
export * from "./LoginAlertPopup.vue?vue&type=script&lang=js"
import style0 from "./LoginAlertPopup.vue?vue&type=style&index=0&id=3534f123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534f123",
  null
  
)

export default component.exports